import { Base } from '@studiometa/js-toolkit';
import { throttle } from '@studiometa/js-toolkit/utils';

/**
 * QuickAddToCartBtn component
 */
export default class QuickAddToCartBtn extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'QuickAddToCartBtn',
    options: {
      product: {
        type: String,
        default: () => '',
      },
    },
  };

  /**
   * Mounted
   */
  mounted() {
    if (this.$options.product !== '') {
      this.event = new CustomEvent('addpanel', {
        detail: {
          product: this.$options.product,
        },
      });

      this.throttledDispatch = throttle(() => {
        window.dispatchEvent(this.event);
      }, 1000);
    }
  }

  /**
   * On click
   */
  onClick() {
    if (this.$options.product !== '') {
      this.throttledDispatch();
    }
  }
}
